export default {"src":"/_next/static/media/construction.b97fc3b5.svg","height":285,"width":589,"blurWidth":0,"blurHeight":0};